import React, {
	Component
} from 'react';
import { store } from '../stores/mainStore';
import { observer } from 'mobx-react';
import styled from 'styled-components';
// import {times} from 'lodash';



const HiddenPreloader = styled.div`
	display: none;
`


@observer
export class TutorialPreload extends Component {
	render() {
		return (
			<HiddenPreloader>
				<img draggable="false" alt="" src={`/assets/languages/${store.settings.language}/tutorial_0a.png`}/>
				<img draggable="false" alt="" src={`/assets/languages/${store.settings.language}/tutorial_0.png`}/>
				<img draggable="false" alt="" src={`/assets/languages/${store.settings.language}/tutorial_16.png`}/>
				<img draggable="false" alt="" src={`/assets/languages/${store.settings.language}/tutorial_17.png`}/>
			</HiddenPreloader>
		)
	}
}